import Link from "next/link";
import { useTranslation } from "next-i18next";

import { Button } from "@mui/material";

import { useCookiesConsent } from "@hooks";

import { CookieBannerButtons, CookieBannerContainer } from "./styles.styled";

const CookieBanner = () => {
  const { t } = useTranslation();
  const { cookiesConsent, setCookiesConsent } = useCookiesConsent();

  if (cookiesConsent !== undefined) return null;

  return (
    <CookieBannerContainer>
      <p>
        <span>{`${t("cookies.info_part_1")} `}</span>

        <Link href="/policy" className="underline">
          {t("cookies.info_part_2")}
        </Link>

        <span>.</span>
      </p>

      <CookieBannerButtons>
        <Button onClick={() => setCookiesConsent(false)}>
          {t("cookies.btn_1")}
        </Button>

        <Button variant="contained" onClick={() => setCookiesConsent(true)}>
          {t("cookies.btn_2")}
        </Button>
      </CookieBannerButtons>
    </CookieBannerContainer>
  );
};

export default CookieBanner;
